
import Base from "@/components/pages/valorizations/internal/observatory/BaseInternalChartValorization.vue";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Component } from "vue-property-decorator";

@Component
export default class NumberOfGeoLocalizedObservations extends Base {
  protected title = "Nombre d'observations géo-localisées";
  protected subTitle = "Observatoire Flore";
  protected description = "";

  protected url =
    "/valorization/observatory/flora/number-of-geo-localized-observations";

  drawData() {
    let vm = this;
    let count = this.data.reduce((prev, cur) => prev + cur["count"], 0);

    this.data = count > 0 ? this.data : [];
    am4core.options.autoSetClassName = true;

    this.chart = am4core.create(this.$refs.chart, am4charts.XYChart3D);
    // this.chart.hiddenState.properties.opacity = 0;

    this.chart.data = this.data;

    this.chart.exporting.menu = new am4core.ExportMenu();
    this.chart.exporting.filePrefix = this.subTitle + " - " + this.title;

    // var label = this.chart.createChild(am4core.Label);
    // label.text = "Faites glisser le curseur pour changer de rayon";
    // label.exportable = false;

    // this.chart.radius = am4core.percent(95);
    // this.chart.startAngle = 270 - 180;
    // this.chart.endAngle = 270 + 180;
    // this.chart.innerRadius = am4core.percent(60);

    const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "year";
    categoryAxis.renderer.labels.template.location = 0.5;
    categoryAxis.renderer.grid.template.strokeOpacity = 0.1;
    // categoryAxis.renderer.axisFills.template.disabled = true;
    categoryAxis.mouseEnabled = false;

    //
    //
    // categoryAxis.renderer.labels.template.hideOversized = false;
    // categoryAxis.renderer.minGridDistance = 20;
    // categoryAxis.renderer.labels.template.horizontalCenter = "left";
    // categoryAxis.renderer.labels.template.verticalCenter = "middle";
    // categoryAxis.tooltip.label.rotation = 270;
    // categoryAxis.tooltip.label.horizontalCenter = "right";
    // categoryAxis.tooltip.label.verticalCenter = "middle";

    const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.grid.template.strokeOpacity = 0.05;
    valueAxis.renderer.axisFills.template.disabled = true;
    valueAxis.renderer.axisAngle = 260;
    valueAxis.renderer.labels.template.horizontalCenter = "right";
    valueAxis.min = 0;

    this.series = this.chart.series.push(new am4charts.ConeSeries());
    this.series.dataFields.valueY = "count";
    this.series.dataFields.categoryX = "year";
    this.series.name = "Nombre d'observations géo-localisées";

    // this.series.columns.template.radarColumn.strokeOpacity = 1;
    this.series.columns.template.tooltipText = "{year}: {valueY.value}";
    // this.series.stacked = true;

    let columnTemplate = this.series.columns.template;
    columnTemplate.strokeWidth = 2;
    columnTemplate.strokeOpacity = 1;
    columnTemplate.stroke = am4core.color("#99b034");
    columnTemplate.fill = am4core.color("#99b034");
    columnTemplate.maxWidth = 100;

    // columnTemplate.adapter.add("fill", (fill, target) => {
    //     return this.chart.colors.getIndex(target.dataItem.index);
    // });
    //
    // columnTemplate.adapter.add("stroke", (stroke, target) => {
    //     return this.chart.colors.getIndex(target.dataItem.index);
    // });

    // this.chart.seriesContainer.zIndex = -1;

    // var slider = this.chart.createChild(am4core.Slider);
    // slider.start = 0.5;
    // slider.exportable = false;
    // slider.events.on("rangechanged", () => {
    //     var start = slider.start;
    //
    //     vm.chart.startAngle = 270 - start * 179 - 1;
    //     vm.chart.endAngle = 270 + start * 179 + 1;
    //
    //     valueAxis.renderer.axisAngle = vm.chart.startAngle;
    // });

    // Add a legend
    this.chart.legend = new am4charts.Legend();
    this.chart.legend.name = "label";
  }
}
